var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"utlz-product-block utlz-reset"},[_c('transition-group',{staticClass:"list-items-wrapper utlz-row",attrs:{"name":"fade","tag":"div"}},_vm._l((_vm.products),function(product){return _c('utlz-product-list-item',{key:product.id,staticClass:"product-list-item",attrs:{"product":product,"blockSize":_vm.config.ItemSize}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }